import React from 'react';
import { ExportStatus, MAX_POLL_ATTEMPTS } from './types';

interface ExportProgressViewProps {
  exportStatus: ExportStatus | null;
  pollAttempts: number;
  progressMessage: string;
}

const ExportProgressView: React.FC<ExportProgressViewProps> = ({
  exportStatus,
  pollAttempts,
  progressMessage
}) => (
  <>
    <div className="d-flex justify-content-center" style={{ minHeight: '100px' }}>
      <div id="loading" />
    </div>
    <p className="text-center text-muted">{progressMessage}</p>
    {exportStatus && (
      <div className="text-center">
        <small className="text-muted" style={{ fontWeight: 500 }}>
          Export ID: {exportStatus.export_id}
        </small>
        <br />
        <small className="text-muted" style={{ fontWeight: 500 }}>
          Checking export status: {pollAttempts}/{MAX_POLL_ATTEMPTS}
        </small>
      </div>
    )}
  </>
);

export default ExportProgressView; 